import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'
import LargeNumber from '../../../helper/large-number'
import { ReactElement } from 'react'

interface Props {
    message?: {
        args: {
            wt: number
            ct: number
        }
    }
}

const codeBefore = `$tags = ['foo', 'foo', 'bar'];
$tags = array_unique($tags);`

const codeAfter = `$tags = ['foo' => 'foo', 'bar' => 'bar'];`

export default class ArrayUnique extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let callTable: ReactElement | null = null
        if (message) {
            callTable = (
                <p>
                    <code>array_unique</code> was called <LargeNumber value={message.args.ct} class="" /> for a total time of{' '}
                    <Milliseconds value={message.args.wt} />.
                </p>
            )
        }

        return (
            <div>
                <p>
                    The Stripe Payment Module for Magento 2 may eagerly update and refresh account data via the Stripe API whenever its
                    loaded via dependency injection. This configuration update is performed even when the Stripe API is not needed on the
                    page.
                </p>
            </div>
        )
    }
}
